import { UseFormReturn } from "react-hook-form";
import { TrocarSenhaForm } from "../../../schemas/trocar_senha";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { PasswordFormInput } from "../../../../../../common/components/password_form_input";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import ValidatePassword from "../../../../../../common/components/ValidatePassword";
import { Alert } from "@mui/material";

/**
 * TrocarSenhaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  successMessage: string | null;
  hookForm: UseFormReturn<TrocarSenhaForm>;
  onClose: () => void;
  onSubmit: (form: TrocarSenhaForm) => void;
};

export const TrocarSenhaModal = ({
  open,
  saving,
  successMessage,
  hookForm,
  onClose,
  onSubmit,
}: Props) => {
  const [senha] = hookForm.watch(["novaSenha"]);

  const error = hookForm.formState.errors.root?.message ?? null;

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={saving}
      title="Trocar senha"
      confirmButtonLabel="Enviar"
      confirmSavingButtonLabel="Enviando..."
      cancelButtonLabel="Fechar"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full py-2 flex flex-col gap-4">
        {
          error && (
            <Alert severity="error">
              <span className="font-bold">Erro: </span>{error}
            </Alert>
          )
        }
        {
          successMessage && (
            <Alert severity="success">
              <span className="font-bold">Sucesso: </span>{successMessage}
            </Alert>
          )
        }
        <DefaultFormInput
          name='login'
          label='Login'
          reactHookForm={hookForm}
        />

        <PasswordFormInput
          name='senhaAtual'
          label="Senha Atual"
          autoComplete="new-password"
          reactHookForm={hookForm}
        />

        <PasswordFormInput
          name='novaSenha'
          label="Nova Senha"
          autoComplete="new-password"
          reactHookForm={hookForm}
        />

        <ValidatePassword
          value={senha ?? ''}
          isValid={() => { }}
        />

        <PasswordFormInput
          name='confirmarNovaSenha'
          label="Confirmar Nova Senha"
          autoComplete="new-password"
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}